import {
  PreferredContactMethodEnum,
  UpdateWorkOrderDto,
  WorkOrderNoteHistory,
  WorkOrderStatusEnum,
  WorkOrderPriorityEnum,
  VendorV2Dto,
  CompanyStaffDto,
  RelatedWorkOrderDto,
  VendorSearchField,
  WorkOrderAttachment,
  Role,
  WorkOrderContactInfoDto,
  WorkOrderCostApprovalEnum,
} from '@inosio/payments-sdk';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Snackbar,
  Tooltip,
  Typography,
  SxProps,
  Theme,
  Checkbox,
  Autocomplete,
  TextField,
  InputAdornment,
  Stack,
  Card,
} from '@mui/material';
import ExternalRefResidentIcon from '../../../icons/ExternalRefResidentIcon.svg';
import ExternalRefPropertyIcon from '../../../icons/ExternalRefPropertyIcon.svg';
import EditTitleIcon from '../../../icons/EditTitleIcon.svg';
import MaintenanceBackIcon from '../../../icons/MaintenanceBackIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import {
  createWorkOrder,
  getDownloadWorkOrderFile,
  getWorkOrderBase64Images,
  getWorkOrderVideos,
  getUpdateWorkOrderDetails,
  selectWorkOrderState,
  getWorkOrderById,
  clearWorkOrderDetailsState,
} from '../sagas/workorderSlice';
import SpinnerWithNoConfirmation from '../../../shared/Modal/spinnerWithNoConfirmation';
import { useEffect, useMemo, useRef, useState } from 'react';
import VideoPlayIcon from '../../../icons/VideoPlayIcon.svg';
import FilePdfIcon from '../../../icons/FilePdfIcon.svg';
import NoAttachmentsIcon from '../../../icons/NoAttachmentsIcon.svg';
import AttachmentsModal from './AttachmentsModal';
import { format, differenceInDays, differenceInHours, differenceInMinutes } from 'date-fns';
import AddNoteIcon from '../../../icons/AddNoteIcon.svg';
import UpdateWorkOrderModal from './UpdateWorkOrderModal';
import UpdateNoteModal from './UpdateNoteModal';
import WorkOrderStatusConfirmationModal from './WorkOrderStatusConfirmationModal';
import HelpIcon from '@mui/icons-material/Help';
import ExportIcon from '../../../icons/ExportIcon.svg';
import SendIcon from '../../../icons/SendIcon.svg';
import SplitIcon from '../../../icons/SplitIcon.svg';
import DeleteMaintenanceIcon from '../../../icons/DeleteMaintenanceIcon.svg';
import ExportOptionsModal from './ExportOptionsModal';
import { selectCurrentUser } from '../../../shared/sagas/auth/authSlice';
import { makeStyles } from '@mui/styles';
import LetterAvatar from '../../../components/LetterAvatar';
import { getPmAssociatedStaff, selectPmConfigSettingsState } from '../../configSettings/sagas/pmConfigSettingsSlice';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import LinkOffIcon from '@mui/icons-material/LinkOff';
import ConfirmModal from './ConfirmModal';
import { getFetchingVendorsData, selectVendorsState } from '../../vendors/sagas/vendorsSlice';
import CompleteWorkOrderModal from './CompleteWorkOrderModal';
import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import UpdateWorkOrderDispositionModal from './UpdateWorkOrderDispositionModal';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { debounce } from '@mui/material/utils';
import CloseIcon from '@mui/icons-material/Close';
import { formatStringToSentenceCase } from '../../../shared/util/formaters';
import { useParams } from 'react-router';
import { WorkOrderDetailsReadOnlyField } from './WorkOrderDetailsReadOnlyField';
import { WorkOrderPhoneField } from './WorkOrderPhoneField';
import SendWorkOrderEmailModal from './SendWorkOrderEmailModal';
import NumberFormat from 'react-number-format';
import EstimateWarningModal from './EstimateWarningModal';

const inputRootStyle = {
  width: '100%',
  maxWidth: '197px',
  height: '27px',
  textAlign: 'center' as 'center',
  borderRadius: '24px',
  border: '2px solid #F1F0F5',
  padding: '0 8px',
  outline: 'none !important',
};

export const scrollStyle: SxProps<Theme> = {
  '&::-webkit-scrollbar': {
    width: 7,
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
    borderRadius: '24px',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'darkgrey',
    borderRadius: '24px',
  },
};

const MenuProps = {
  PaperProps: {
    sx: {
      borderRadius: '24px',
    },
  },
};

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    background: '#FFFFFF',
    borderRadius: '24px',
  },
  StatusButtonStyle: {
    color: '#39A2DB !important',
    border: '2px solid #39A2DB !important',
    boxShadow: 'none !important',
    borderRadius: '24px !important',
    fontFamily: "'Open Sans', sans-serif !important",
    fontSize: '14px !important',
    fontWeight: '700 !important',
    fontStyle: 'normal !important',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#39A2DB !important',
      color: 'white !important',
      border: '2px solid #39A2DB !important',
    },
    width: '150px !important',
    height: '40px !important',
    marginLeft: '20px !important',
  },
  StatusLabel: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '14px !important',
    lightHeight: '16px !important',
    color: '#000 !important',
  },
  HeaderLabel: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '600 !important',
    fontSize: '18px !important',
    lightHeight: '22px !important',
    color: '#000 !important',
  },
  StatusSelect: {
    textAlign: 'center',
    borderRadius: '24px !important',
    width: '100%',
    maxWidth: '197px !important',
    height: '90% !important',
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '14px !important',
    lightHeight: '22px !important',
    color: '#000000 !important',
    '& .MuiOutlinedInput-notchedOutline': {
      border: '2px solid #F1F0F5 !important',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '2px solid #F1F0F5 !important',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: '2px solid #F1F0F5 !important',
    },
    '& .MuiSvgIcon-root ': {
      fill: '#F1F0F5 !important',
    },
  },
  AssigneeSelect: {
    textAlign: 'center',
    borderRadius: '24px !important',
    width: '100%',
    maxWidth: '300px !important',
    height: '90% !important',
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '400 !important',
    fontSize: '16px !important',
    lightHeight: '22px !important',
    color: '#39A2DB !important',
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '24px !important',
      border: '2px solid #39A2DB !important',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: '2px solid #39A2DB !important',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: '2px solid #39A2DB !important',
    },
    '& .MuiSvgIcon-root ': {
      fill: '#39A2DB !important',
    },
    '&.Mui-disabled .MuiSvgIcon-root ': {
      fill: '#F1F0F5 !important',
    },
    '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      border: '2px solid #F1F0F5 !important',
    },
    '& input.MuiInputBase-input::placeholder': {
      color: '#3CA2DC',
      textAlign: 'center',
      opacity: 1,
    },
    '& .MuiAutocomplete-endAdornment': {
      position: 'unset',
      margin: 0,
    },
  },
  phoneInput: {
    '& .form-control': {
      width: '100%',
      borderRadius: '24px',
      height: '42px  !important',
      border: '2px solid #EEEEEE',
    },
  },
  phoneInputWrapper: {
    position: 'relative',
  },
  phoneIcon: {
    position: 'absolute',
    top: '50%',
    right: '10px',
    transform: 'translateY(-50%)',
    cursor: 'pointer',
    color: 'black',
    zIndex: 1,
  },
  labelText: {
    fontFamily: 'Open Sans !important',
    fontStyle: 'normal !important',
    fontWeight: '700 !important',
    fontSize: '18px !important',
    lineHeight: '25px !important',
    color: '#14142B',
  },
  inputRoot: {
    ...inputRootStyle,
    '&:hover': {
      borderColor: 'rgb(0, 0, 0, 0.87)',
    },
    '&:focus': {
      borderColor: 'rgb(25, 118, 210)',
    },
  },
}));

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export interface WorkOrderDetailProps {
  onBack: () => void;
}

function WorkOrderDetails(props: WorkOrderDetailProps) {
  const { id: workOrderIdRouteParam } = useParams<{ id: string }>();

  //work order status options
  //important! the values should match the entries in the db
  const StatusValues = [
    { key: WorkOrderStatusEnum.NeedsReview, value: 'Needs Review' },
    { key: WorkOrderStatusEnum.OwnerDiscussion, value: 'Owner Discussion' },
    { key: WorkOrderStatusEnum.VendorDiscussion, value: 'Vendor Discussion' },
    { key: WorkOrderStatusEnum.SentToVendor, value: 'Sent to Vendor' },
    { key: WorkOrderStatusEnum.WorkInProgress, value: 'Work in Progress' },
    { key: WorkOrderStatusEnum.ObtainingQuotes, value: 'Obtaining Quotes' },
    { key: WorkOrderStatusEnum.InvoiceReceived, value: 'Invoice Received' },
  ];

  //work order priority options
  //important! the values should match the entries in the db
  const PriorityValues = [
    { key: WorkOrderPriorityEnum.Standard, value: 'Standard' },
    { key: WorkOrderPriorityEnum.Low, value: 'Low' },
    { key: WorkOrderPriorityEnum.High, value: 'High' },
    { key: WorkOrderPriorityEnum.Urgent, value: 'Urgent' },
  ];

  const classes = useStyles();
  const dispatch = useDispatch();
  const matchesMobile = useMediaQuery('(max-width:420px)');
  const matchesIpad = useMediaQuery('(max-width:768px)');

  //selectors
  const currentUser = useSelector(selectCurrentUser);
  const { Vendors: AllVendors, isFetchingVendors } = useSelector(selectVendorsState);
  const {
    WorkOrderImagesData,
    isFetchingBase64Images,
    isUpdatingWorkOrderDetails,
    isAddingWorkOrderNoteFailed,
    isDownloadingWorkOrderFilesFailed,
    isUpdatingWorkOrderDetailsFailed,
    isDeletingWorkOrderNoteFailed,
    isFetchingBase64ImagesFailed,
    isFetchingVideosFailed,
    isCreatingWorkOrder,
    isCreatingWorkOrderSuccess,
    isCreatingWorkOrderFailed,
    workOrderDetailDto,
    isGettingWorkOrderSuccess,
    isSendingWorkOrderEmailSuccess,
    isSendingWorkOrderEmailFailed,
    SendingWorkOrderEmailError,
  } = useSelector(selectWorkOrderState);

  const {
    WorkOrderId,
    ResidentExternalRef2,
    PropertyExternalRef2,
    ResidentFirstName,
    ResidentLastName,
    PropertyName,
    Title,
    Description,
    EventHistory,
    WorkOrderNotes,
    Status,
    Uuid,
    CreatedDate,
    Priority,
    Vendors,
    Staff,
    CompletedDate,
    ContactName,
    ContactEmail,
    ContactPhone,
    PreferredContactMethod,
    AccessNotes,
    PetNotes,
    Attachments,
    Disposition,
    Estimate,
    CostLimit,
    WorkOrderCostApproval,
  } = workOrderDetailDto;

  const { associatedCompanyStaff } = useSelector(selectPmConfigSettingsState);

  const isVendorUser = currentUser?.currentProfile.role === Role.Vendor;
  const { ParentWorkOrder, ChildrenWorkOrders } = workOrderDetailDto;

  //local state
  const [staffsSearchKey, setStaffsSearchKey] = useState('');
  const [vendorsSearchKey, setVendorsSearchKey] = useState('');
  const [selectedStaff, setSelectedStaff] = useState<CompanyStaffDto[]>(Staff ?? []);
  const [selectedVendors, setSelectedVendors] = useState<VendorV2Dto[]>(Vendors ?? []);
  const [openAttachmentsModal, setOpenAttachmentsModal] = useState(false);
  const [titleAttachmentsModal, setTitleAttachmentsModal] = useState('');
  const [base64UrlAttachmentsModal, setBase64UrlAttachmentsModal] = useState('');
  const [remoteUuid, setRemoteUuid] = useState('');
  const [documentFileType, setDocumentFileType] = useState('');
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [openUpdateWorkOrderModal, setOpenUpdateWorkOrderModal] = useState(false);
  const [openUpdateDispositionModal, setOpenUpdateDispositionModal] = useState(false);
  const [openUpdateNoteModal, setOpenUpdateNoteModal] = useState(false);
  const [selectedNote, setSelectedNote] = useState<WorkOrderNoteHistory>();
  const [noteModalUsedFor, setNoteModalUsedFor] = useState('');
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [selectedWorkOrderStatus, setSelectedWorkOrderStatus] = useState<WorkOrderStatusEnum>();
  const [disposition, setDisposition] = useState<string>();
  const [openExportOptionsModal, setOpenExportOptionsModal] = useState(false);
  const [status, setStatus] = useState('Needs Review');
  const [priority, setPriority] = useState('Standard');
  const [relatedWorkOrders, setRelatedWorkOrders] = useState<RelatedWorkOrderDto[]>([]);
  const [splitWorkOrderFlag, setSplitWorkOrderFlag] = useState(false);
  const [openLinkOffModal, setOpenLinkOffModal] = useState(false);
  const [selectedRelatedWOUuid, setSelectedRelatedWOUuid] = useState('');
  const [errorSnackBarOpen, setErrorSnackBarOpen] = useState(false);
  const [warningSnackBarOpen, setWarningSnackBarOpen] = useState(false);
  const [globalWarning, setGlobalWarning] = useState('');
  const [globalError, setGlobalError] = useState('');
  const [successSnackBarOpen, setSuccessSnackBarOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [openCompleteWorkOrderModal, setOpenCompleteWorkOrderModal] = useState(false);
  const [openSendWorkOrderEmailModal, setOpenSendWorkOrderEmailModal] = useState(false);
  const [pdfAttachments, setPdfAttachments] = useState<WorkOrderAttachment[]>([]);
  const [videoAttachments, setVideoAttachments] = useState<WorkOrderAttachment[]>([]);
  const topBarRef = useRef<HTMLDivElement>(null);
  const [currentUpdatingField, setCurrentUpdatingField] = useState<keyof WorkOrderContactInfoDto>();
  const [costLimitValue, setCostLimitValue] = useState<number | null | undefined>(null);
  const [workOrderEstimateValue, setWorkOrderEstimateValue] = useState<number | null | undefined>(null);
  const [workOrderContactPreference, setWorkOrderContactPreference] = useState<string>('');
  const [openEstimateWarningModal, setOpenEstimateWarningModal] = useState<boolean>(false);

  //this builds a list of values to put in the pick list.
  const getStaffListOptions = () => {
    const currentlySelectedStaff: CompanyStaffDto[] = selectedStaff;
    if (staffsSearchKey.length >= 2 && !associatedCompanyStaff.isFetching) {
      const newStaffOptions = (associatedCompanyStaff.staff || []).filter((st) => {
        return st.FirstName.toLowerCase().indexOf(staffsSearchKey.toLowerCase()) > -1 || st.LastName.toLowerCase().indexOf(staffsSearchKey.toLowerCase()) > -1;
      });
      return newStaffOptions.slice(0, 15);
    } else {
      return [...currentlySelectedStaff];
    }
  };

  const getVendorOptionsList = () => {
    const currentlySelectedVendors: VendorV2Dto[] = selectedVendors;
    if (vendorsSearchKey.length >= 2 && !isFetchingVendors) {
      //* make a new list which includes our currently selected fellas, but exclude those same fellas from the search response list so they're not duplicated
      const list: VendorV2Dto[] = [...currentlySelectedVendors, ...AllVendors?.Rows?.filter((v) => !currentlySelectedVendors.some((csv) => csv.Uuid === v.Uuid))];
      return list;
    } else {
      return [...currentlySelectedVendors];
    }
  };

  const fetchVendorListWithDebounce = useMemo(
    () =>
      debounce((debouncedVendorsSearchKey) => {
        if (debouncedVendorsSearchKey.length >= 2) {
          dispatch(
            getFetchingVendorsData({
              SearchField: VendorSearchField.Name,
              SearchValue: debouncedVendorsSearchKey,
              RangeSize: 15,
              StartIndex: 0,
            }),
          );
        }
      }, 500),
    [],
  );

  const handleClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackBarOpen(false);
  };

  const getDifferenceInDates = (firstDate: Date, secondDate: Date) => {
    const diffDates = differenceInDays(firstDate, secondDate);
    if (diffDates === 0) {
      const diffHours = differenceInHours(firstDate, secondDate);
      if (diffHours === 0) {
        const diffMins = differenceInMinutes(firstDate, secondDate);
        if (diffMins === 0) return 'just now';

        return `${diffMins} ${diffMins > 1 ? 'minutes' : 'minute'}`;
      } else {
        return `${diffHours} ${diffHours === 1 ? 'hour' : 'hours'}`;
      }
    } else {
      return `${diffDates} ${diffDates === 1 ? 'day' : 'days'}`;
    }
  };

  const statusChangeHandler = (e: any) => {
    setStatus(e.target.value);

    const selectedStatus = StatusValues.find((status) => status.value === e.target.value);

    selectedStatus &&
      dispatch({
        type: getUpdateWorkOrderDetails.type,
        payload: {
          woUuid: Uuid,
          updateWoDto: {
            Status: selectedStatus?.key,
          } as UpdateWorkOrderDto,
        },
      });
  };

  const priorityChangeHandler = (e: any) => {
    setPriority(e.target.value);
    const selectedPriority = PriorityValues.find((priority) => priority.value === e.target.value);
    selectedPriority &&
      dispatch({
        type: getUpdateWorkOrderDetails.type,
        payload: {
          woUuid: Uuid,
          updateWoDto: {
            Priority: selectedPriority.key,
          } as UpdateWorkOrderDto,
        },
      });
  };

  //check if status history has updated and show the updated one
  const checkEventUpdate = () => {
    return workOrderDetailDto?.EventHistory ? workOrderDetailDto?.EventHistory : EventHistory;
  };

  const linkOffWorkOrder = (uuid: string) => {
    setSelectedRelatedWOUuid(uuid);
    setOpenLinkOffModal(true);
  };

  const confirmLinkOffCallback = () => {
    dispatch({
      type: getUpdateWorkOrderDetails.type,
      payload: {
        woUuid: Uuid, //current opened workorder Uuid
        updateWoDto: {
          RemoveLinkageFromWorkOrderUuid: selectedRelatedWOUuid,
        } as UpdateWorkOrderDto,
      },
    });
    setRelatedWorkOrders((wos) => wos.filter((wo) => wo.Uuid !== selectedRelatedWOUuid));
    setOpenLinkOffModal(false);
  };

  const splitWorkOrder = () => {
    dispatch({
      type: createWorkOrder.type,
      payload: {
        cloneWorkOrderUuid: Uuid,
      },
    });
    setSplitWorkOrderFlag(true);
  };

  const handleErrorAlertClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setErrorSnackBarOpen(false);
  };

  const handleWarningAlertClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setWarningSnackBarOpen(false);
    setGlobalWarning('');
  };

  const handleConfirmCompleteWorkOrder = (disposition: string) => {
    setOpenCompleteWorkOrderModal(false);
    setOpenConfirmationModal(true);
    setSelectedWorkOrderStatus(WorkOrderStatusEnum.Completed);
    setDisposition(disposition);
  };

  //-----Staff Details-------//
  const handleStaffSelectionChange = (completeListOfSelectedStaff: CompanyStaffDto[]) => {
    setSelectedStaff(completeListOfSelectedStaff);

    dispatch({
      type: getUpdateWorkOrderDetails.type,
      payload: {
        woUuid: Uuid,
        updateWoDto: {
          Staff: completeListOfSelectedStaff.map((pStaff) => {
            return { Uuid: pStaff.Uuid };
          }),
        } as UpdateWorkOrderDto,
      },
    });
  };

  //-----Vendor Details-------//
  const handleVendorSelectionChange = (newSelectedVendors: VendorV2Dto[]) => {
    setSelectedVendors(newSelectedVendors);
    dispatch({
      type: getUpdateWorkOrderDetails.type,
      payload: {
        woUuid: Uuid,
        updateWoDto: {
          Vendors: newSelectedVendors.map((pVendor) => {
            return { Uuid: pVendor.Uuid };
          }),
        } as UpdateWorkOrderDto,
      },
    });
    setVendorsSearchKey('');
    newSelectedVendors.forEach((vendor) => {
      if (!vendor.Email) {
        setGlobalWarning('Email not sent.');
        setWarningSnackBarOpen(true);
      }
    });
  };

  useEffect(() => {
    if (isSendingWorkOrderEmailSuccess) {
      setSuccessSnackBarOpen(true);
      setSuccessMessage('Email successfully sent.');
    }
  }, [isSendingWorkOrderEmailSuccess]);

  const handleSuccessAlert = (event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setSuccessSnackBarOpen(false);
  };

  const getStatusContent = () => (
    <React.Fragment>
      <Grid container px={matchesMobile ? 1 : 2} py={0.5} alignItems="center">
        <Grid item xs={6}>
          <Typography className={classes.StatusLabel}>{Status?.includes('Completed') || workOrderDetailDto?.Status?.includes('Completed') ? 'Completed' : 'In Progress'}</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography className={classes.HeaderLabel}>
            {Status?.includes('Completed') || workOrderDetailDto?.Status?.includes('Completed')
              ? getDifferenceInDates(new Date(), CompletedDate ? new Date(CompletedDate) : new Date())
              : getDifferenceInDates(new Date(), new Date(CreatedDate))}
          </Typography>
        </Grid>
      </Grid>
      <Grid container px={matchesMobile ? 1 : 2} py={0.5}>
        <Grid item xs={6}>
          <Typography className={classes.StatusLabel}>Created</Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography className={classes.StatusLabel}>{format(new Date(CreatedDate), 'MM/dd/yyyy')}</Typography>
        </Grid>
      </Grid>
      <Grid container px={matchesMobile ? 1 : 2} py={0.5} alignItems="center">
        <Grid item xs={3}>
          <Typography className={classes.StatusLabel}>Priority</Typography>
        </Grid>
        <Grid item xs={9}>
          <FormControl sx={{ height: 31, borderRadius: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Select
              onChange={priorityChangeHandler}
              value={priority}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              className={classes.StatusSelect}
              MenuProps={MenuProps}
              disabled={currentUser?.currentProfile.role === Role.MaintenanceStaff || isVendorUser}
            >
              <MenuItem disabled value={priority}>
                {priority}
              </MenuItem>
              {PriorityValues.filter((option) => !(option.value === priority)).map((option: any) => {
                return (
                  <MenuItem value={option.key} key={option.key}>
                    {option.value}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container px={matchesMobile ? 1 : 2} pt={0.5} alignItems="center">
        <Grid item xs={3}>
          <Typography className={classes.StatusLabel}>Status</Typography>
        </Grid>
        <Grid item xs={9}>
          <FormControl sx={{ height: 31, borderRadius: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Select
              onChange={statusChangeHandler}
              value={status}
              displayEmpty
              inputProps={{ 'aria-label': 'Without label' }}
              className={classes.StatusSelect}
              MenuProps={MenuProps}
              disabled={isVendorUser}
            >
              <MenuItem disabled value={status}>
                {status}
              </MenuItem>
              {StatusValues.filter((option) => !(option.value === status)).map((option: any) => {
                return (
                  <MenuItem value={option.value} key={option.key}>
                    {option.value}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Grid container px={matchesMobile ? 1 : 2} pt={0.5} alignItems="center">
        <Grid item xs={3}>
          <Typography className={classes.StatusLabel}>Cost Limit</Typography>
        </Grid>
        <Grid item xs={9} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <NumberFormat
            onValueChange={(values) => {
              setCostLimitValue(values.floatValue != null ? values.floatValue * 100 : null);
            }}
            value={costLimitValue == null ? null : costLimitValue / 100}
            thousandSeparator
            isNumericString
            fixedDecimalScale
            decimalScale={2}
            prefix="$"
            className={classes.inputRoot}
            placeholder="$0.00"
            onBlur={handleBlurCostLimit}
          />
        </Grid>
      </Grid>
      <Grid container px={matchesMobile ? 1 : 2} pt={0.5} alignItems="center">
        <Grid item xs={3}>
          <Typography className={classes.StatusLabel}>Contact Preference</Typography>
        </Grid>
        <Grid item xs={9} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography className={classes.StatusLabel}>{workOrderContactPreference}</Typography>
        </Grid>
      </Grid>
      <Grid container px={matchesMobile ? 1 : 2} pt={0.5} alignItems="center">
        <Grid item xs={3}>
          <Typography className={classes.StatusLabel}>Estimate</Typography>
        </Grid>
        <Grid item xs={9} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <NumberFormat
            onValueChange={(values) => {
              setWorkOrderEstimateValue(values.floatValue != null ? values.floatValue * 100 : null);
            }}
            value={workOrderEstimateValue == null ? null : workOrderEstimateValue / 100}
            thousandSeparator
            isNumericString
            fixedDecimalScale
            decimalScale={2}
            prefix="$"
            className={classes.inputRoot}
            placeholder="$0.00"
            onBlur={handleBlurEstimate}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );

  const getHistoryContent = () => (
    <React.Fragment>
      <Grid item xs={12} height={30}>
        <Typography
          sx={{
            fontFamily: 'Work Sans',
            fontStyle: 'normal',
            fontWeight: 600,
            fontSize: '18px',
            color: '#14142B',
            marginRight: '10px',
          }}
        >
          History
          <Tooltip title="This is an overview of the workorder's status changes and milestones." placement="right">
            <HelpIcon sx={{ fontSize: 17, color: '#C4C4C4', cursor: 'pointer' }} />
          </Tooltip>
        </Typography>
      </Grid>
      {isUpdatingWorkOrderDetails ? (
        <Grid item xs={12} display="flex" alignItems="center" justifyContent="center" height="80%">
          <SpinnerWithNoConfirmation />
        </Grid>
      ) : (
        <Grid
          item
          xs={12}
          sx={{
            maxHeight: 150,
            width: '100%',
            overflow: 'auto',
            ...scrollStyle,
          }}
        >
          {checkEventUpdate()?.map((event, i, row) => {
            return (
              <Grid container key={i}>
                <Grid item xs={12} display="Flex" justifyContent="center">
                  <Typography
                    sx={{
                      fontFamily: 'Work Sans',
                      fontStyle: 'normal',
                      fontWeight: 600,
                      fontSize: '16px',
                      color: '#14142B',
                      textAlign: 'center',
                    }}
                  >
                    {event?.EventDescription}
                  </Typography>
                </Grid>
                <Grid item xs={12} display="Flex" justifyContent="center">
                  <Typography
                    sx={{
                      fontFamily: 'Work Sans',
                      fontStyle: 'normal',
                      fontWeight: 500,
                      fontSize: '14px',
                      color: '#14142B',
                    }}
                  >
                    {format(new Date(event?.EventDate), "MM/dd/yyyy 'at' h:mm a")}
                  </Typography>
                </Grid>
                <Grid item xs={12} display="Flex" justifyContent="center">
                  {i + 1 === row.length ? <></> : <Divider orientation="vertical" flexItem sx={{ height: '30px' }} />}
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      )}
    </React.Fragment>
  );

  const handleBlurCostLimit = () => {
    if (costLimitValue !== null) {
      dispatch({
        type: getUpdateWorkOrderDetails.type,
        payload: {
          woUuid: Uuid,
          updateWoDto: {
            CostLimit: costLimitValue,
          } as UpdateWorkOrderDto,
        },
      });
    }
  };

  const handleBlurEstimate = () => {
    if (workOrderEstimateValue && costLimitValue && workOrderEstimateValue > costLimitValue) {
      setOpenEstimateWarningModal(true);
    }
    if (workOrderEstimateValue !== null) {
      dispatch({
        type: getUpdateWorkOrderDetails.type,
        payload: {
          woUuid: Uuid,
          updateWoDto: {
            Estimate: workOrderEstimateValue,
          } as UpdateWorkOrderDto,
        },
      });
    }
  };

  //new stuff

  useEffect(() => {
    if (workOrderIdRouteParam) {
      dispatch(clearWorkOrderDetailsState());
      dispatch({ type: getWorkOrderById.type, payload: { workOrderId: workOrderIdRouteParam } });
    }

    return () => {
      //clear state when leaving this component.
      dispatch(clearWorkOrderDetailsState());
    };
  }, [dispatch, workOrderIdRouteParam]);

  useEffect(() => {
    if (isGettingWorkOrderSuccess) {
      setSelectedVendors(Vendors || []);
      setSelectedStaff(Staff || []);
      setPdfAttachments(Attachments?.filter((att) => att.FileType?.includes('pdf')) || []);
      setVideoAttachments(Attachments?.filter((att) => att.FileType?.includes('video')) || []);
      const imageTypeAttachments = Attachments?.filter((att) => att.FileType?.includes('image'));
      imageTypeAttachments?.forEach((att) => {
        dispatch({
          type: getWorkOrderBase64Images.type,
          payload: att.RemoteUuid,
        });
      });

      setWorkOrderEstimateValue(Estimate);

      setCostLimitValue(CostLimit);

      if (!!WorkOrderCostApproval) {
        let contactPreference = '';
        if (WorkOrderCostApproval === WorkOrderCostApprovalEnum.AboveLimit) {
          contactPreference = 'Above this limit';
        } else if (WorkOrderCostApproval === WorkOrderCostApprovalEnum.Always) {
          contactPreference = 'Always call';
        } else if (WorkOrderCostApproval === WorkOrderCostApprovalEnum.Never) {
          contactPreference = 'Never Call';
        }
        setWorkOrderContactPreference(contactPreference);
      }
    }

    //when wo is received, fetch docs if any.
  }, [isGettingWorkOrderSuccess, dispatch]);

  //end new stuff
  useEffect(() => {
    //refetch vendor as they type
    fetchVendorListWithDebounce(vendorsSearchKey);
  }, [vendorsSearchKey]);

  useEffect(() => {
    //we fetch only if we need to (ie, we haven't fetched yet and we aren't actively fetching)
    if (!associatedCompanyStaff.isCompleted && !associatedCompanyStaff.isFetching) {
      dispatch(getPmAssociatedStaff());
    }
  }, [dispatch]);

  useEffect(() => {
    if (workOrderDetailDto?.Status || Status) setStatus(workOrderDetailDto?.Status || Status);
  }, [workOrderDetailDto, Status]);

  useEffect(() => {
    if (workOrderDetailDto?.Priority || Priority) setPriority(workOrderDetailDto?.Priority || Priority);
  }, [workOrderDetailDto, Priority]);

  useEffect(() => {
    let wos: RelatedWorkOrderDto[] = [];
    if (!!ParentWorkOrder) wos = [...wos, ParentWorkOrder];
    if (!!ChildrenWorkOrders) wos = [...wos, ...ChildrenWorkOrders];
    setRelatedWorkOrders(wos);
  }, [ParentWorkOrder, ChildrenWorkOrders]);

  useEffect(() => {
    if (splitWorkOrderFlag && isCreatingWorkOrderSuccess) {
      dispatch({ type: getWorkOrderById.type, payload: { workOrderId: workOrderIdRouteParam } }); //refresh this current guy to show the split on the bottom of ui
      setSplitWorkOrderFlag(true);
      window.open(`/pmui/workorders/${workOrderDetailDto.WorkOrderId}`);
    }
  }, [isCreatingWorkOrderSuccess]);

  useEffect(() => {
    setGlobalError('');
    if (
      isFetchingBase64ImagesFailed ||
      isAddingWorkOrderNoteFailed ||
      isDeletingWorkOrderNoteFailed ||
      isDownloadingWorkOrderFilesFailed ||
      isUpdatingWorkOrderDetailsFailed ||
      isFetchingVideosFailed ||
      isCreatingWorkOrderFailed
    ) {
      setErrorSnackBarOpen(true);
      setGlobalError('Something went wrong. Please try again later.');
    }
  }, [isFetchingBase64ImagesFailed, isAddingWorkOrderNoteFailed, isDeletingWorkOrderNoteFailed, isDownloadingWorkOrderFilesFailed, isUpdatingWorkOrderDetailsFailed, isFetchingVideosFailed]);

  useEffect(() => {
    setGlobalError('');
    if (SendingWorkOrderEmailError && isSendingWorkOrderEmailFailed) {
      setErrorSnackBarOpen(true);
      setGlobalError(SendingWorkOrderEmailError.message);
    }
  }, [SendingWorkOrderEmailError, isSendingWorkOrderEmailFailed]);

  //fetch configs for the pg this wo belongs to

  const onHandleUpdateResidentDetail = (newValue: string, attribute: keyof WorkOrderContactInfoDto) => {
    setCurrentUpdatingField(attribute);
    dispatch({
      type: getUpdateWorkOrderDetails.type,
      payload: {
        woUuid: Uuid,
        updateWoDto: {
          ContactInfo: {
            [attribute]: newValue,
          },
        },
      },
    });
  };

  const handleOpenSendWorkOrderEmailModal = () => {
    if (workOrderDetailDto.Staff?.length || workOrderDetailDto.Vendors?.length) {
      setOpenSendWorkOrderEmailModal(true);
    }
  };

  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: 'calc( 100vh - 144px )',
      }}
      className={classes.gridContainer}
      style={{ position: 'relative' }}
    >
      <Grid container sx={{ height: 'calc( 100vh - 144px )' }} width="100%">
        {isGettingWorkOrderSuccess && associatedCompanyStaff?.isCompleted && (
          <>
            <Grid item xs={12} display="flex" alignItems="center" ref={topBarRef}>
              <Grid container display="flex" justifyContent="space-between" p={2.5} alignItems={matchesIpad ? 'baseline' : 'center'}>
                <Grid
                  item
                  display="flex"
                  flexDirection={matchesIpad ? 'column' : 'row'}
                  alignItems={matchesIpad ? 'baseline' : 'center'}
                  width={matchesMobile ? '100%' : matchesIpad ? '50%' : 'unset'}
                >
                  <img src={MaintenanceBackIcon} style={{ height: '20px', width: '20px', marginRight: '30px', cursor: 'pointer' }} alt="back" onClick={props.onBack} />

                  <Box sx={{ display: 'flex', mt: matchesIpad ? 1 : 0 }}>
                    <img src={ExternalRefResidentIcon} style={{ height: '20px', width: '20px' }} alt="ExternalRefResidentIcon" />
                    <Typography id="subTitle" ml={2} mr={2}>{`${ResidentFirstName} ${ResidentLastName} | ${ResidentExternalRef2}`}</Typography>
                  </Box>

                  <Box sx={{ display: 'flex', mt: matchesIpad ? 1 : 0 }}>
                    <img src={ExternalRefPropertyIcon} style={{ height: '20px', width: '20px' }} alt="ExternalRefPropertyIcon" />
                    <Typography id="subTitle" ml={2}>{`${PropertyName} | ${PropertyExternalRef2} | Work Order ID: ${WorkOrderId}`}</Typography>
                  </Box>
                </Grid>

                <Grid item display="flex" alignItems="center" sx={{ mt: matchesMobile ? 1 : 0 }}>
                  <Tooltip title="Send email to work order assignees." placement="bottom">
                    <img
                      src={SendIcon}
                      style={{
                        height: '20px',
                        width: '20px',
                        cursor: 'pointer',
                        marginRight: '15px',
                        marginTop: '3px',
                        filter: workOrderDetailDto.Staff?.length || workOrderDetailDto.Vendors?.length ? 'none' : 'grayscale(100%)',
                      }}
                      alt="SendEmailIcon"
                      onClick={handleOpenSendWorkOrderEmailModal}
                    />
                  </Tooltip>

                  {!(Status?.includes('Closed') || workOrderDetailDto?.Status?.includes('Closed')) && currentUser?.currentProfile.role !== Role.MaintenanceStaff && (
                    <Tooltip title="Delete work order." placement="bottom">
                      <img
                        src={DeleteMaintenanceIcon}
                        style={{ height: '20px', width: '20px', cursor: 'pointer' }}
                        alt="DeleteMaintenanceIcon"
                        onClick={() => {
                          setOpenConfirmationModal(true);
                          setSelectedWorkOrderStatus(WorkOrderStatusEnum.Closed);
                        }}
                      />
                    </Tooltip>
                  )}
                  <Tooltip title="Download work order as PDF." placement="bottom">
                    <img
                      src={ExportIcon}
                      style={{ height: '20px', width: '20px', marginLeft: '20px', cursor: 'pointer' }}
                      alt="ExportMaintenanceIcon"
                      onClick={() => {
                        setOpenExportOptionsModal(true);
                      }}
                    />
                  </Tooltip>

                  {isCreatingWorkOrder ? (
                    <CircularProgress size={20} sx={{ color: '#39A2DB', marginLeft: '20px' }} />
                  ) : (
                    currentUser?.currentProfile.role !== Role.MaintenanceStaff && (
                      <Tooltip title="Split work order." placement="bottom">
                        <img src={SplitIcon} style={{ height: '20px', width: '20px', marginLeft: '20px', cursor: 'pointer' }} alt="Split Work Order" onClick={splitWorkOrder} />
                      </Tooltip>
                    )
                  )}
                  {!status?.includes('Completed') && (
                    <Button variant="outlined" className={classes.StatusButtonStyle} onClick={() => setOpenCompleteWorkOrderModal(true)}>
                      Completed
                    </Button>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} height={`calc( 100% - ${topBarRef?.current?.clientHeight ?? 0}px )`}>
              <Grid container height="100%" sx={{ borderTop: '2px solid #EEEEEE', overflowY: 'auto', ...scrollStyle }}>
                <Grid item xs={12} lg={isVendorUser ? 8 : 6} sx={{ p: 2, height: matchesIpad ? 'unset' : '100%' }}>
                  <Box
                    sx={{
                      border: '3px solid #F1F0F5',
                      borderRadius: '24px',
                      height: matchesIpad ? 'unset' : '100%',
                    }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '47px',
                        borderBottom: '3px solid #F1F0F5',
                        px: 2,
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Work Sans',
                          fontWeight: 600,
                          fontSize: '18px',
                          lineHeight: '22px',
                        }}
                      >
                        Request Details
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        height: 'calc( 100% - 50px )',
                        overflowY: 'auto',
                        ...scrollStyle,
                      }}
                    >
                      <Grid container px={matchesMobile ? 1 : 2} pb={2} sx={{ maxHeight: 166 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: 50, width: '100%' }}>
                          <Typography
                            sx={{
                              fontFamily: 'Work Sans',
                              fontStyle: 'normal',
                              fontWeight: 600,
                              fontSize: '18px',
                              color: '#14142B',
                              marginRight: '10px',
                            }}
                          >
                            {Title}
                          </Typography>
                          {currentUser?.currentProfile.role !== Role.MaintenanceStaff && (
                            <IconButton
                              onClick={() => {
                                setOpenUpdateWorkOrderModal(true);
                              }}
                            >
                              <img src={EditTitleIcon} style={{ height: '26px', width: '26px', cursor: 'pointer' }} alt={'EditTitleIcon'} />
                            </IconButton>
                          )}
                        </Box>
                        <Box
                          sx={{
                            backgroundColor: '#F1F0F5',
                            borderRadius: '18px',
                            maxHeight: 100,
                            width: '100%',
                            overflowY: 'auto',
                            ...scrollStyle,
                          }}
                          p={2}
                        >
                          <Typography
                            sx={{
                              fontFamily: 'Work Sans',
                              fontStyle: 'normal',
                              fontWeight: 400,
                              fontSize: '18px',
                              color: '#14142B',
                              marginRight: '10px',
                            }}
                          >
                            {Description}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid container sx={{ borderTop: '2px solid #EEEEEE' }} px={matchesMobile ? 1 : 2} py={1}>
                        <Grid container pb={1}>
                          <Typography
                            sx={{
                              fontFamily: 'Work Sans',
                              fontStyle: 'normal',
                              fontWeight: 600,
                              fontSize: '18px',
                              color: '#14142B',
                            }}
                          >
                            Resident Details
                            <Tooltip title="These details were supplied by the Resident when completing the Maintenance Request." placement="right">
                              <HelpIcon sx={{ fontSize: 17, color: '#C4C4C4', cursor: 'pointer' }} />
                            </Tooltip>
                          </Typography>
                        </Grid>
                        <WorkOrderDetailsReadOnlyField
                          width={matchesMobile ? 12 : 5.85}
                          value={ContactName}
                          label={'Contact Name'}
                          handleClickCopyToClipboard={() => {
                            setSnackBarOpen(true);
                          }}
                          isEditable={true}
                          isUpdating={isUpdatingWorkOrderDetails && currentUpdatingField === 'ContactName'}
                          onBlurUpdate={(newValue) => onHandleUpdateResidentDetail(newValue, 'ContactName')}
                        />
                        <Grid item xs={0.3}></Grid>
                        <WorkOrderDetailsReadOnlyField
                          width={matchesMobile ? 12 : 5.85}
                          value={ContactEmail}
                          label={'Email'}
                          handleClickCopyToClipboard={() => {
                            setSnackBarOpen(true);
                          }}
                          isEditable={true}
                          isUpdating={isUpdatingWorkOrderDetails && currentUpdatingField === 'ContactEmail'}
                          onBlurUpdate={(newValue) => onHandleUpdateResidentDetail(newValue, 'ContactEmail')}
                          methodPreferred={PreferredContactMethod === PreferredContactMethodEnum.Email ? PreferredContactMethod : null}
                        />
                        <WorkOrderPhoneField
                          width={matchesMobile ? 12 : 5.85}
                          label={PreferredContactMethod === PreferredContactMethodEnum.Call || PreferredContactMethod === PreferredContactMethodEnum.Text ? 'Phone (Preferred)' : 'Phone'}
                          value={ContactPhone}
                          iconProps={{
                            className: classes.phoneIcon,
                          }}
                          formControlProps={{
                            className: classes.phoneInputWrapper,
                          }}
                          inputProps={{
                            containerClass: classes.phoneInput,
                            country: 'us',
                            defaultErrorMessage: 'Invalid Phone Number',
                          }}
                          isEditable={true}
                          isUpdating={isUpdatingWorkOrderDetails && currentUpdatingField === 'ContactPhone'}
                          onBlurUpdate={(newValue) => onHandleUpdateResidentDetail(newValue, 'ContactPhone')}
                          handleClickCopyToClipboard={() => {
                            setSnackBarOpen(true);
                          }}
                        />
                        <Grid item xs={0.3}></Grid>
                        {PetNotes && (
                          <WorkOrderDetailsReadOnlyField
                            width={matchesMobile ? 12 : 5.85}
                            value={PetNotes}
                            label={'Type of Pets?'}
                            handleClickCopyToClipboard={() => {
                              setSnackBarOpen(true);
                            }}
                          />
                        )}
                        {AccessNotes && (
                          <WorkOrderDetailsReadOnlyField
                            width={12}
                            value={AccessNotes}
                            label={'Access Notes'}
                            handleClickCopyToClipboard={() => {
                              setSnackBarOpen(true);
                            }}
                          />
                        )}
                      </Grid>
                      {Disposition && (
                        <Grid container px={matchesMobile ? 1 : 2} pb={2} sx={{ borderTop: '2px solid #EEEEEE', maxHeight: 166 }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: 50, width: '100%' }}>
                            <Typography
                              sx={{
                                fontFamily: 'Work Sans',
                                fontStyle: 'normal',
                                fontWeight: 600,
                                fontSize: '18px',
                                color: '#14142B',
                                marginRight: '10px',
                              }}
                            >
                              Work Completed
                            </Typography>
                            {currentUser?.currentProfile.role !== Role.MaintenanceStaff && (
                              <IconButton
                                onClick={() => {
                                  setOpenUpdateDispositionModal(true);
                                }}
                              >
                                <img src={EditTitleIcon} style={{ height: '26px', width: '26px', cursor: 'pointer' }} alt={'EditTitleIcon'} />
                              </IconButton>
                            )}
                          </Box>
                          <Box
                            sx={{
                              backgroundColor: '#F1F0F5',
                              borderRadius: '18px',
                              maxHeight: 100,
                              width: '100%',
                              overflowY: 'auto',
                              ...scrollStyle,
                            }}
                            p={2}
                          >
                            <Typography
                              sx={{
                                fontFamily: 'Work Sans',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                fontSize: '18px',
                                color: '#14142B',
                                marginRight: '10px',
                              }}
                            >
                              {Disposition}
                            </Typography>
                          </Box>
                        </Grid>
                      )}
                      <Grid container sx={{ borderTop: '2px solid #EEEEEE' }} px={matchesMobile ? 1 : 2} py={1}>
                        <Typography
                          sx={{
                            fontFamily: 'Work Sans',
                            fontStyle: 'normal',
                            fontWeight: 600,
                            fontSize: '18px',
                            color: '#14142B',
                            marginRight: '10px',
                          }}
                        >
                          Attachments
                          <Tooltip title="These were submitted by the Resident when creating the maintenance request." placement="right">
                            <HelpIcon sx={{ fontSize: 17, color: '#C4C4C4', cursor: 'pointer' }} />
                          </Tooltip>
                        </Typography>
                        <Grid container mt={1}>
                          {isFetchingBase64Images ? (
                            <Grid item xs={12} display="flex" alignItems="center" justifyContent="center" height="100%">
                              <SpinnerWithNoConfirmation />
                            </Grid>
                          ) : !!Attachments?.length ? (
                            <Grid item xs={12} display="flex" sx={{ overflowY: 'auto' }}>
                              {WorkOrderImagesData.map((img, index) => {
                                return (
                                  <Box
                                    onClick={() => {
                                      setOpenAttachmentsModal(true);
                                      setTitleAttachmentsModal('Photo');
                                      setBase64UrlAttachmentsModal(`data:${img.contentType};base64,${img.fileBase64}`);
                                      if (img.remoteUuid) setRemoteUuid(img?.remoteUuid);
                                      setDocumentFileType(img.contentType);
                                    }}
                                    key={index}
                                  >
                                    <Grid item mr={0.5}>
                                      <img src={`data:${img.contentType};base64,${img.fileBase64}`} style={{ height: '81px', width: '81px', cursor: 'pointer' }} alt="attachment" />
                                    </Grid>
                                  </Box>
                                );
                              })}
                              {videoAttachments?.map((att, index) => {
                                return (
                                  <Box
                                    onClick={() => {
                                      dispatch({
                                        type: getWorkOrderVideos.type,
                                        payload: att.RemoteUuid,
                                      });
                                      setOpenAttachmentsModal(true);
                                      setTitleAttachmentsModal('Video');
                                      setRemoteUuid(att.RemoteUuid);
                                      setDocumentFileType(att.FileType);
                                    }}
                                    key={index}
                                  >
                                    <Grid
                                      item
                                      mr={0.5}
                                      sx={{ height: '81px', width: '81px', backgroundColor: '#565656', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}
                                    >
                                      <img src={VideoPlayIcon} alt={'videoplayicon'} />
                                    </Grid>
                                  </Box>
                                );
                              })}
                              {pdfAttachments?.map((att, index) => {
                                return (
                                  <Box
                                    onClick={() => {
                                      dispatch({
                                        type: getDownloadWorkOrderFile.type,
                                        payload: {
                                          remoteUuid: att.RemoteUuid,
                                          fileType: att.FileType,
                                        },
                                      });
                                    }}
                                    key={index}
                                  >
                                    <Grid
                                      item
                                      mr={0.5}
                                      sx={{ height: '81px', width: '81px', backgroundColor: '#565656', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}
                                    >
                                      <img src={FilePdfIcon} style={{ color: 'red' }} alt="FilePdfIcon" />
                                    </Grid>
                                  </Box>
                                );
                              })}
                            </Grid>
                          ) : (
                            <>
                              <Grid item xs={12} display="flex" justifyContent="center">
                                <img src={NoAttachmentsIcon} alt={'NoAttachmentsIcon'} />
                              </Grid>
                              <Grid item xs={12} display="flex" justifyContent="center">
                                <Typography
                                  sx={{
                                    fontFamily: 'Work Sans',
                                    fontStyle: 'normal',
                                    fontWeight: 400,
                                    fontSize: '14px',
                                    color: 'grey',
                                    marginTop: '4px',
                                  }}
                                >
                                  No files found
                                </Typography>
                              </Grid>
                            </>
                          )}
                        </Grid>
                      </Grid>
                    </Box>
                  </Box>
                </Grid>
                {isVendorUser ? (
                  <Grid item xs={12} lg={4} sx={{ p: 2, height: matchesIpad ? 'unset' : '100%' }}>
                    <Grid
                      container
                      sx={{
                        border: '3px solid #F1F0F5',
                        borderRadius: '24px',
                        height: '100%',
                      }}
                    >
                      <Grid
                        container
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          height: '47px',
                          borderBottom: '3px solid #F1F0F5',
                          px: 2,
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: 'Work Sans',
                            fontWeight: 600,
                            fontSize: '18px',
                            lineHeight: '22px',
                          }}
                        >
                          Control Panel
                        </Typography>
                      </Grid>
                      <Grid
                        container
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          height: 'calc( 100% - 50px )',
                        }}
                      >
                        <Grid container px={matchesMobile ? 1 : 2} pb={2} height="100%" sx={{ alignItems: 'flex-start' }}>
                          <Grid container>{getStatusContent()}</Grid>

                          <Grid container borderTop="2px solid #EEEEEE" px={matchesMobile ? 1 : 2} py={1} height="calc( 100% - 200px )">
                            {getHistoryContent()}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                ) : (
                  <Grid item xs={12} lg={6} sx={{ py: 2, pr: { lg: 2 }, height: matchesIpad ? 'unset' : '100%' }}>
                    <Grid
                      container
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '50px',
                        borderBottom: '3px solid #F1F0F5',
                        px: 2,
                      }}
                    >
                      <Typography
                        sx={{
                          fontFamily: 'Work Sans',
                          fontWeight: 600,
                          fontSize: '18px',
                          lineHeight: '22px',
                        }}
                      >
                        Control Panel
                      </Typography>
                    </Grid>
                    <Grid container height="calc( 100% - 50px )">
                      <Grid item xs={12} sm={6} height={matchesIpad ? 'unset' : '100%'}>
                        <Grid container>{getStatusContent()}</Grid>
                        <Grid container borderTop="2px solid #EEEEEE" px={matchesMobile ? 1 : 2} mt={2} height="calc( 100% - 400px )">
                          {getHistoryContent()}
                        </Grid>
                        <Grid container borderTop="2px solid #EEEEEE" height="19%" mt="2px" px={matchesMobile ? 1 : 2} pb={1}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: 50, width: '100%' }}>
                            <Typography
                              sx={{
                                fontFamily: 'Work Sans',
                                fontStyle: 'normal',
                                fontWeight: 600,
                                fontSize: '18px',
                                color: '#14142B',
                              }}
                            >
                              Relates To
                              <Tooltip title="You can add or remove an association between work orders." placement="right">
                                <HelpIcon sx={{ fontSize: 17, color: '#C4C4C4', cursor: 'pointer' }} />
                              </Tooltip>
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              width: '100%',
                              height: matchesIpad ? 'unset' : 'calc( 100% - 50px )',
                              pl: 2,
                              overflow: 'auto',
                              ...scrollStyle,
                            }}
                          >
                            <Grid container display="flex" justifyContent="center">
                              {relatedWorkOrders.map((wo, index) => {
                                return (
                                  <Grid container mb={1} key={index}>
                                    <Grid item xs={9}>
                                      <Typography
                                        sx={{
                                          width: '100%',
                                          fontFamily: 'Work Sans',
                                          fontStyle: 'normal',
                                          fontWeight: 400,
                                          fontSize: '14px',
                                          color: '#000000',
                                          wordWrap: 'break-word',
                                        }}
                                      >
                                        {`Work Order ID: ${wo.WorkOrderId}`}
                                      </Typography>
                                      <Typography
                                        sx={{
                                          width: '100%',
                                          fontFamily: 'Work Sans',
                                          fontStyle: 'normal',
                                          fontWeight: 400,
                                          fontSize: '14px',
                                          color: '#000000',
                                          wordWrap: 'break-word',
                                        }}
                                      >
                                        {wo.Title}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={3} display="flex" alignItems="center">
                                      <OpenInNewIcon onClick={() => window.open(`/pmui/workorders/${wo.WorkOrderId}`)} sx={{ fontSize: 18, color: '#14142B', cursor: 'pointer', mr: '9px' }} />
                                      {currentUser?.currentProfile.role !== Role.MaintenanceStaff && (
                                        <LinkOffIcon onClick={() => linkOffWorkOrder(wo.Uuid)} sx={{ fontSize: 18, color: '#14142B', cursor: 'pointer' }} />
                                      )}
                                    </Grid>
                                  </Grid>
                                );
                              })}
                            </Grid>
                          </Box>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} sm={6} height={matchesIpad ? 'unset' : '100%'}>
                        <Grid container sx={{ borderLeft: '2px solid #EEEEEE' }} py={1} height="100%">
                          <Grid container px={matchesMobile ? 1 : 2} mt={1} mb={1} py={1}>
                            <Grid item xs={12}>
                              <Typography className={classes.HeaderLabel}>
                                Assignees
                                <Tooltip title="You may assign one or more staff members or vendors." placement="right">
                                  <HelpIcon sx={{ fontSize: 17, color: '#C4C4C4', cursor: 'pointer' }} />
                                </Tooltip>
                              </Typography>
                            </Grid>

                            <Grid container my={1} alignItems="center">
                              <Typography className={classes.StatusLabel} sx={{ mr: 1 }}>
                                Staff
                              </Typography>
                              {selectedStaff.map((staff, index) => (
                                <LetterAvatar name1={staff.FirstName.toUpperCase()} name2={staff.LastName?.toUpperCase()} key={staff.Uuid} />
                              ))}
                            </Grid>

                            <FormControl sx={{ width: '100%', height: 38, borderRadius: 24, flexDirection: 'row', mt: 0.6 }}>
                              <Autocomplete
                                multiple
                                id="staff-select"
                                className={classes.AssigneeSelect}
                                options={getStaffListOptions()}
                                getOptionLabel={(option: CompanyStaffDto) => `${formatStringToSentenceCase(option.FirstName)} ${formatStringToSentenceCase(option.LastName)}`}
                                disableCloseOnSelect={false}
                                disableClearable
                                loading={false}
                                value={selectedStaff}
                                noOptionsText={associatedCompanyStaff.isFetching && staffsSearchKey.length >= 2 ? 'Loading...' : 'Start typing to search'}
                                isOptionEqualToValue={(option, value) => {
                                  return option.Uuid === value.Uuid;
                                }}
                                onChange={(event, selectedOptions: CompanyStaffDto[], reason, details) => {
                                  handleStaffSelectionChange(selectedOptions);
                                  setStaffsSearchKey('');
                                }}
                                renderOption={(props, option: CompanyStaffDto, { selected }) => {
                                  return (
                                    <li {...props} key={option.Uuid}>
                                      <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
                                      {`${formatStringToSentenceCase(option.FirstName)} ${formatStringToSentenceCase(option.LastName)}`}
                                    </li>
                                  );
                                }}
                                renderInput={(params) => {
                                  return (
                                    <TextField
                                      {...params}
                                      size="small"
                                      label=""
                                      placeholder="Search & Select Staff Members"
                                      InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                          <Stack direction="row" alignItems="center" color="#39A2DB">
                                            {associatedCompanyStaff.isFetching && staffsSearchKey.length >= 2 ? <CircularProgress color="inherit" size={16} /> : null}
                                            <InputAdornment position="end">
                                              <IconButton size="small" aria-label="delete search key" onClick={() => setStaffsSearchKey('')} onMouseDown={() => setStaffsSearchKey('')} edge="start">
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            </InputAdornment>
                                            {params.InputProps.endAdornment}
                                          </Stack>
                                        ),
                                      }}
                                      onChange={(evt: any) => {
                                        const newVal = evt.target.value;
                                        setStaffsSearchKey(newVal);
                                      }}
                                      inputProps={{
                                        ...params.inputProps,
                                        value: staffsSearchKey,
                                      }}
                                    />
                                  );
                                }}
                                renderTags={(value: readonly CompanyStaffDto[], getTagProps) => <></>}
                              />
                            </FormControl>

                            <Grid container mb={0.6} mt={2} alignItems="center">
                              <Typography className={classes.StatusLabel} sx={{ mr: 1 }}>
                                Vendors
                              </Typography>
                              {selectedVendors.map((vendor, index) => (
                                <LetterAvatar name1={vendor.Name ?? 'Vendor Name'} key={index} />
                              ))}
                            </Grid>
                            <FormControl sx={{ width: '100%', height: 38, borderRadius: 24, flexDirection: 'row', mt: 0.6 }}>
                              <Autocomplete
                                multiple
                                id="vendor-select"
                                className={classes.AssigneeSelect}
                                options={getVendorOptionsList()}
                                getOptionLabel={(option: VendorV2Dto) => `${option.Name}`}
                                disableCloseOnSelect={false}
                                disableClearable
                                loading={false}
                                value={selectedVendors}
                                noOptionsText={isFetchingVendors && vendorsSearchKey.length >= 2 ? 'Loading...' : 'Start typing to search'}
                                isOptionEqualToValue={(option, value) => {
                                  return option.Uuid === value.Uuid;
                                }}
                                onChange={(event, selectedVendors: VendorV2Dto[]) => {
                                  handleVendorSelectionChange(selectedVendors);
                                }}
                                renderOption={(props, option: VendorV2Dto, { selected }) => {
                                  return (
                                    <li {...props} key={option.Uuid}>
                                      <Checkbox icon={icon} checkedIcon={checkedIcon} style={{ marginRight: 8 }} checked={selected} />
                                      {`${option.Name}`}
                                    </li>
                                  );
                                }}
                                renderInput={(params) => {
                                  return (
                                    <TextField
                                      {...params}
                                      size="small"
                                      label=""
                                      placeholder="Select vendors"
                                      InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                          <Stack direction="row" alignItems="center" color="#39A2DB">
                                            {isFetchingVendors && vendorsSearchKey.length >= 2 ? <CircularProgress color="inherit" size={16} /> : null}
                                            <InputAdornment position="end">
                                              <IconButton size="small" aria-label="delete search key" onClick={() => setVendorsSearchKey('')} onMouseDown={() => setVendorsSearchKey('')} edge="start">
                                                <CloseIcon fontSize="small" />
                                              </IconButton>
                                            </InputAdornment>
                                            {params.InputProps.endAdornment}
                                          </Stack>
                                        ),
                                      }}
                                      onChange={(evt: any) => {
                                        const newVal = evt.target.value;
                                        setVendorsSearchKey(newVal);
                                      }}
                                      inputProps={{
                                        ...params.inputProps,
                                        value: vendorsSearchKey,
                                      }}
                                    />
                                  );
                                }}
                                renderTags={(value: readonly VendorV2Dto[], getTagProps) => <></>}
                              />
                            </FormControl>
                          </Grid>
                          <Grid container height="60%" borderTop="2px solid #EEEEEE" px={matchesMobile ? 1 : 2} pb={1}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: 50, width: '100%' }}>
                              <Typography
                                sx={{
                                  fontFamily: 'Work Sans',
                                  fontStyle: 'normal',
                                  fontWeight: 600,
                                  fontSize: '18px',
                                  color: '#14142B',
                                  marginRight: '10px',
                                  ml: 2,
                                }}
                              >
                                Note Pad
                                <Tooltip title="These notes are to help you and your staff stay updated on this workorder. They will not be shared with Residents." placement="right">
                                  <HelpIcon sx={{ fontSize: 17, color: '#C4C4C4', cursor: 'pointer' }} />
                                </Tooltip>
                              </Typography>
                              <IconButton
                                onClick={() => {
                                  setNoteModalUsedFor('Add');
                                  setOpenUpdateNoteModal(true);
                                }}
                              >
                                <img src={AddNoteIcon} style={{ height: '26px', width: '26px' }} alt={'AddNoteIcon'} />
                              </IconButton>
                            </Box>
                            <Box
                              sx={{
                                height: 'calc( 100% - 50px )',
                                pl: 2,
                                overflow: 'auto',
                                ...scrollStyle,
                              }}
                            >
                              <Grid container display="flex" justifyContent="center">
                                {WorkOrderNotes.map((note, index) => {
                                  return (
                                    <Grid item xs={12} key={index}>
                                      <Grid
                                        onClick={() => {
                                          setNoteModalUsedFor('View');
                                          setOpenUpdateNoteModal(true);
                                          setSelectedNote(note);
                                        }}
                                        item
                                        p={1}
                                        sx={{ backgroundColor: '#F1F0F5', borderRadius: '10px' }}
                                      >
                                        <Typography
                                          sx={{
                                            width: '100%',
                                            fontFamily: 'Work Sans',
                                            fontStyle: 'normal',
                                            fontWeight: 400,
                                            fontSize: '14px',
                                            color: '#14142B',
                                            marginRight: '10px',
                                            wordWrap: 'break-word',
                                          }}
                                        >
                                          {note.NoteDescription}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={12} display="Flex" justifyContent="flex-end" mx={1} mb={1}>
                                        <Typography
                                          sx={{
                                            fontFamily: 'Work Sans',
                                            fontStyle: 'normal',
                                            fontWeight: 500,
                                            fontSize: '10px',
                                            color: '#14142B',
                                          }}
                                        >
                                          {format(new Date(note.NoteDate), "MM/dd/yyyy 'at' h:mm a")}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  );
                                })}
                              </Grid>
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </>
        )}
        <Snackbar anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }} open={snackBarOpen} autoHideDuration={4000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
            Copied
          </Alert>
        </Snackbar>
        <Snackbar anchorOrigin={{ horizontal: 'center', vertical: 'top' }} open={errorSnackBarOpen} autoHideDuration={4000} onClose={handleErrorAlertClose}>
          <Alert onClose={handleErrorAlertClose} severity="error">
            {globalError}
          </Alert>
        </Snackbar>
        <Snackbar anchorOrigin={{ horizontal: 'center', vertical: 'top' }} open={warningSnackBarOpen} autoHideDuration={4000} onClose={handleWarningAlertClose}>
          <Alert onClose={handleWarningAlertClose} severity="warning">
            {globalWarning}
          </Alert>
        </Snackbar>
        <Snackbar anchorOrigin={{ horizontal: 'center', vertical: 'top' }} open={successSnackBarOpen} autoHideDuration={4000} onClose={handleSuccessAlert}>
          <Alert onClose={handleSuccessAlert} severity="success">
            {successMessage}
          </Alert>
        </Snackbar>
        {/* Enlarge attachments in this modal */}
        <AttachmentsModal
          open={openAttachmentsModal}
          remoteUuid={remoteUuid}
          onClose={() => {
            setOpenAttachmentsModal(false);
            setTitleAttachmentsModal('');
            setBase64UrlAttachmentsModal('');
            setRemoteUuid('');
          }}
          title={titleAttachmentsModal}
          base64Url={base64UrlAttachmentsModal}
        />

        {/* Update workorder title and description in this modal */}
        <UpdateWorkOrderModal
          open={openUpdateWorkOrderModal}
          WorkOrderUuid={Uuid}
          Title={Title}
          Description={Description}
          onClose={() => {
            setOpenUpdateWorkOrderModal(false);
          }}
        />

        {/* Update workorder disposition in this modal */}
        <UpdateWorkOrderDispositionModal
          open={openUpdateDispositionModal}
          WorkOrderUuid={Uuid}
          Disposition={Disposition}
          onClose={() => {
            setOpenUpdateDispositionModal(false);
          }}
        />

        {/* Add or Delete a Note in this modal */}
        <UpdateNoteModal
          open={openUpdateNoteModal}
          onClose={() => {
            setSelectedNote({} as WorkOrderNoteHistory);
            setNoteModalUsedFor('');
            setOpenUpdateNoteModal(false);
          }}
          usedFor={noteModalUsedFor} //Add or View
          note={selectedNote ?? ({} as WorkOrderNoteHistory)}
          workOrderUuid={Uuid}
        />

        {/* Complete work order modal */}
        <CompleteWorkOrderModal
          open={openCompleteWorkOrderModal}
          workOrderUuid={Uuid}
          onClose={() => setOpenCompleteWorkOrderModal(false)}
          onConfirmComplete={handleConfirmCompleteWorkOrder}
          disposition={Disposition}
        />

        <SendWorkOrderEmailModal open={openSendWorkOrderEmailModal} workOrderUuid={Uuid} onClose={() => setOpenSendWorkOrderEmailModal(false)} workOrderDto={workOrderDetailDto} />

        {/* Confirmation modal when we change the work order status to completed or closed*/}
        <WorkOrderStatusConfirmationModal
          WorkOrderUuid={Uuid}
          open={openConfirmationModal}
          onClose={() => {
            setOpenConfirmationModal(false);
          }}
          status={selectedWorkOrderStatus}
          disposition={disposition}
        />

        {/* Export Options Modal */}
        <ExportOptionsModal
          open={openExportOptionsModal}
          onClose={() => {
            setOpenExportOptionsModal(false);
          }}
          WorkOrderUuid={Uuid}
          workOrderDto={workOrderDetailDto}
          fileType={documentFileType}
        />

        {/* Link Off Modal */}
        <ConfirmModal open={openLinkOffModal} title={'Confirm Unlinking'} closeCallback={() => setOpenLinkOffModal(false)} confirmCallback={confirmLinkOffCallback} />

        <EstimateWarningModal
          open={openEstimateWarningModal}
          title={'Estimate Exceeds Owner Cost Limit'}
          body={'The estimate entered exceeds the Owner’s default cost limit.'}
          closeCallback={() => setOpenEstimateWarningModal(false)}
          confirmCallback={() => setOpenEstimateWarningModal(false)}
        />
      </Grid>
    </Card>
  );
}

export default WorkOrderDetails;
